import "./loginStyle.css";
import Login from "./Login";
import Register from "./Register";
import { useState } from "react";

const Layout = ({ setIsLoggedIn, formType = "login" }) => {
  const [currentFormType, setCurrentFormType] = useState(formType);
  const isLogin = currentFormType === "login";
  
  return (
    <div>
      {isLogin ? (
        <Login setIsLoggedIn={setIsLoggedIn} setFormType={setCurrentFormType} />
      ) : (
        <Register setIsLoggedIn={setIsLoggedIn} setFormType={setCurrentFormType} />
      )}
    </div>
  );
};

export default Layout;
